var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgIconMagnify = _ref => {
  let {
    svgRef,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    ref: svgRef
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#aaa",
    stroke: "#aaa",
    d: "M18.3 10.445a6.112 6.112 0 0 0 1.712-4.223A6.327 6.327 0 0 0 13.6 0a6.327 6.327 0 0 0-6.41 6.222 6.327 6.327 0 0 0 6.41 6.221 6.51 6.51 0 0 0 3.84-1.239l4.768 4.626a.582.582 0 0 0 .406.169.568.568 0 0 0 .406-.967zM8.351 6.222a5.18 5.18 0 0 1 5.252-5.1 5.18 5.18 0 0 1 5.252 5.1 5.174 5.174 0 0 1-5.252 5.1 5.18 5.18 0 0 1-5.252-5.1z",
    transform: "translate(.5 .5) translate(-7.19)"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIconMagnify, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/icon-magnify.7668f7bd.svg";
export { ForwardRef as ReactComponent };